// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"9fbf5f9881514170c85c","678":"2f40d6b30baf6bdde922","883":"3e835e1a3e7d447a0ef0"}[chunkId] + ".js";
};